export default "../fonts/akzidgrtskprolig-webfont.968bc8a4aa358cfd3a8cd086b4cacb8a.ttf";